export function smoothScroll(id) {
  if (typeof document !== 'undefined') {
    var element = document.getElementById(id);
    element.scrollIntoView({
      block: 'start',
      behavior: 'smooth'
    });
  }
}